import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  computed,
  signal,
} from '@angular/core';

import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';

export interface MarkAllOfficialDialogData {
  count: number;
  roundNumber: number;
  tournamentName: string;
}

@Component({
  selector: 'app-mark-all-official-dialog',
  standalone: true,
  imports: [],
  templateUrl: './mark-all-official-dialog.component.html',
  styleUrls: ['./mark-all-official-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarkAllOfficialDialogComponent {
  readonly count = signal(this.data.count);
  readonly roundNumber = signal(this.data.roundNumber);
  readonly tournamentName = signal(this.data.tournamentName);

  readonly header = computed(
    () => `Mark all ${this.count()} Unofficial Scorecards Official?`
  );

  constructor(
    private readonly dialogRef: DialogRef<boolean>,
    @Inject(DIALOG_DATA) private readonly data: MarkAllOfficialDialogData
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
